<template>
  <el-dialog :visible="true" @close="handleCloseDialog" append-to-body  :close-on-click-modal="false">
      <el-input v-model="tempUrl"></el-input>

      
       <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onFinish()">确定</el-button>
        </span>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import fileSelector from "@client/components/file-selector";

export default {
  name: "attr-qk-iframe",
  props: {
      url: {
          type: String,
          default: 'https://www.yun-kong.com'
      }
  },
  components: {
    fileSelector
  },
  data() {
    return {
        tempUrl: ''
    }
  },
  mounted() {
      this.tempUrl = this.url;
  },
  watch: {},
  computed: {
    ...mapState({
      editActiveElement: state => state.editor.editActiveElement,
        projectData: state => state.editor.projectData
    }),
    ...mapGetters([
        'activePage'
    ]),
  },
  methods: {
      onFinish() {

          let findResult = this.activePage.elements.some(element => {
            if (element.uuid === this.editActiveElement.uuid) {
                element.propsValue.url = this.tempUrl;
                return true;
            }

            return false;
        });

        if (!findResult) {
            let newEle = _.cloneDeep(this.editActiveElement);
            newEle.propsValue.url = this.tempUrl;
            newEle.commonStyle.width = this.projectData.width || 1920;;
            newEle.commonStyle.height = this.projectData.height || 1080;;

            this.activePage.elements.push(newEle);
        }

        this.handleCloseDialog();
      },
    handleCloseDialog() {
      this.$store.dispatch('editActiveElement', null);
    }
  }
}
</script>

<style scoped>
</style>
